module.exports = __webpack_public_path__ + "img/etapa4.77efe031.png";